import React from 'react';
import {connect} from 'react-redux';
import {Navigate, Outlet, useLocation, useParams} from 'react-router-dom';
import {isLoggedIn, showLogin, logout, checkEmail, close, login, validateCsrf} from 'common/login/loginActions';
import {getSettings} from 'www/actions/settingsActions';
import {loadBanners} from 'www/actions/bannerAction';
import { checkTC } from 'www/util/tc-helpers';


const AppRoute = () => {
    const {organization} = useParams();
    const {pathname} = useLocation();
    let { search} = useLocation();
    const location = useLocation();

    if (!search && location && location.state){
        search = location.state.search;
    }
    return (
        checkTC() ? <Outlet/> : <Navigate to={`/${organization}/showTermConditions`}  replace = {true}  state={{ pathname : {pathname} , search : {search} , location : {location}} }/>
    )
}

export default connect(
    ({login, settings, globalBanners}) => ({loginState: login, settings, globalBanners}),
    {getSettings, showLogin, login, isLoggedIn, validateCsrf, loadBanners}
)(AppRoute)

